import { configureStore } from "@reduxjs/toolkit";
import { chatBotCreatorSlice } from "./store/chatBotCreatorSlice";

export const store = configureStore({
  reducer: {
    chatBotCreatorStore: chatBotCreatorSlice.reducer,
  },
});
